import React, { Component } from "react";

import { Header, Image } from "semantic-ui-react";
import Testimonials from "../components/Testimonials";
import Neha from "../assets/images/testimony/neha.jpeg";
import Nikhil from "../assets/images/testimony/nikhil.jpg";
import Phone from "../assets/images/elan_insta.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/styles/socialCause.scss";
import Slider from "react-slick";
import SocialCauseSlide from "../components/SocialCause";
import SocialPhoto from "../assets/images/social-cause/EachOnGiveOne1.jpg";
import Devarakonda from '../assets/images/social-cause/Vijay-IIT-Hyderabad-e1518458326252.jpg';
import QuitSmoking from '../assets/images/social-cause/Quit Smoking.jpg';
// import Masoom from '../assets/images/social-cause/Masoom1.jpg';

class SocialCause extends Component {
  constructor() {
    super();

    this.data = [
      {
        name: "Mr Nikhil Chandwani",
        position:"Author, Tedx Speaker",
        photo: Nikhil,
        testimony:
          "It was a pleasure being invited by your team to take a virtual session and share my views on mental health. Your team was instrumental in properly organising the talk. The interviewer demonstrated tremendous skill and conducted the discussion in a professional manner. Thank you.",
      },
      {
        name: "Ms Neha Ghosh",
        position:"Mental Health Blogger",
        photo: Neha,
        testimony:
          "The talk show was interactive and there were a lot of good questions asked. There was a genuine interest in learning about the ways to manage and take care of ones mental health. Students participated openly and we had a intelligent conversation",
      },
    ];

    this.social_causes = [
      // {
      //   name: "LGBTQ",
      //   photo: SocialPhoto,
      //   details:
      //     "The recent decision taken by the Supreme Court regarding the removal of section 377 is an appreciable thing and a great help for the LGBT community. Even then, acceptance of this change among the people is not up to the required level. So this year with a social cause theme LGBT Pride, we are going to organise events like Marathon to increase awareness among people about the LGBT movement.",
      // },
      {
        name: "My_EcoPledge",
        photo: Devarakonda,
        details: `This eco-pledge was a positive environmental action that aimed to contribute in helping protect the environment and reduce the use of world's finite resources. The main goal behind this was to make people understand that sustainability is not just a goal to be reached but a way of being, a principle we all must be guided by`
      },
      // {
      //   name:'Each One Give One',
      //   photo:SocialPhoto,
      //   details: "asgdhdngfhgdbvdsbfg nbfgvfasdbfngfgefgdsvf" +
      //       "bngbbg edbfnvfbdnfbdnbfd gfdfbd.",
      // },
      {
        name:'Masoom',
        photo: SocialPhoto,
        details:"It is very unfortunate that the practice of child labor in India still continues to persist with more than 80 lakh children toiling in fields, factories, shops and elsewhere.\n" +
            "In this scenario, it is important to spread awareness as it ensures that communities tap growth, education, and employment opportunities and create a socially and economically developed society  in which children suffer less.",
      },
      {
        name:"Quit Smoking",
        photo: QuitSmoking,
        details:"Smoking is still the leading preventable cause of death and disease in the world. It causes immediate damage to the body which can lead to long-term health problems.\n" +
            "The main goal of this initiative was to build public awareness of the immediate health damage caused by smoking and exposure to second hand smoke."
      }
    ];
  }

  settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  render() {
    return (
      <div className={"social-cause"}>
        <div className={"section-1"}>
          <div className={"titles"}>
            <p className={"title"}>
              Mental Health
              <br />
              Awareness
            </p>
            <p className={"subtitle"}>Break the stigma</p>
          </div>

          <div className={"textbox textbox-1"}>
            <Header className={"heading"}>ABOUT THE THEME</Header>
            <p>
              The social cause theme for this year is "Mental Health". Our
              society is still plagued by misconceptions and myths about mental
              health and the only way to get rid of them is by talking about it
              more often. We aim at doing our bit in demystifying and breaking
              the barriers to mental health. This was a conscious decision taken
              by our members after pooling in our ideas because we thought "If
              not now then when?" The lockdown of 2020 has taught us so many
              lessons one of them being prioritizing mental health like physical
              health. We have eye-opening discussions and initiatives planned
              for turning this vision into reality.
            </p>
          </div>
        </div>

        <div className={"section-2"}>
          <div className={"textbox textbox-2"}>
            <Header className={"heading"}>SANGHARSH</Header>
            <p>
              Initiatives are introduced like our mental health live session,
              Sangharsh where we invite renowned mental health speakers and
              experts to share their knowledge to our 43,000+ community. Neha
              Ghosh who is one of the top 9 mental health bloggers is one of our
              recent guests who graced us with their presence. We have a team to
              brainstorm the possible questions that one can have regarding all
              aspects of mental health like anxiety, depression, overthinking,
              pressure and we discuss it with the invited experts. Bite-sized
              information from the session is also posted on our Instagram page.
            </p>
          </div>
          <Image src={Phone} className={"image"} />
        </div>

        <div className={"testimonials"}>
          <Slider {...this.settings}>
            {this.data.map((item) => {
              return (
                <Testimonials
                  name={item.name}
                  photo={item.photo}
                  testimony={item.testimony}
                  position={item.position}
                  key={item.name}
                />
              );
            })}
          </Slider>
        </div>

        <div className={"previous-social-cause"}>
          <Slider {...this.settings}>
            {this.social_causes.map(item=> {
              return <SocialCauseSlide key={item.name} {...item}/>
            })}
          </Slider>
        </div>
      </div>
    );
  }
}

export default SocialCause;
